import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-navy-900 text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-270" data-mp="369pga49jt16e">
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-271" data-mp="31jhe67m7cct4" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-272" data-mp="31h4nn62dou4g">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-sun-400" data-id="element-273" data-mp="3g7c97unomt9d">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-274" data-mp="3b893e7zvoj0c" /> El precio de lanzamiento termina en:
        </p>
        <Countdown light className="mt-5 scale-110" data-id="element-275" data-mp="3p80m2m1canko" />
        <p className="mt-7 font-bold text-navy-100" data-id="element-276" data-mp="3l6ymg43ig9i6">Después sube el precio y no vuelve a bajar.</p>

        <div className="mx-auto mt-6 max-w-xl rounded-lg border border-navy-700 bg-navy-950 p-4 text-left text-sm" data-id="element-277" data-mp="1uu0sxbsdu052">
          <p className="flex items-center justify-between gap-3 font-bold" data-id="element-278" data-mp="1quik3edu5fil">
            <span className="inline-flex items-center" data-id="element-279" data-mp="2su6bn6pe4bua">
              <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-red-500" aria-hidden="true" data-id="element-280" data-mp="2srlbqn8nk5z6" />
              Cupos al precio de lanzamiento
            </span>
            <span className="text-sun-400" data-id="element-281" data-mp="32qj6i7wo8vqm">Quedan pocos</span>
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-navy-800" data-id="element-282" data-mp="37jm0gh5d277c">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '66%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.9,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-full rounded-full bg-sun-400" data-id="element-283" data-mp="3ci6t9via9olr" />
          </div>
          <p className="mt-1 text-right text-xs text-navy-200" data-id="element-284" data-mp="3qhomcn2m3o0x">66% de los cupos tomados</p>
        </div>
      </div>
      <div className="energy-bar h-2 w-full" aria-hidden="true" data-id="element-285" data-mp="1r5ce1skoisj5" />
    </section>;
}